<template>
  <section>
    <div class="container">
      <h1>Development History</h1>
      <div class="box">
        <div class="wrap animate__animated animate__fadeInUp">
          <div class="iconfont icon-jiantou-copy" @click="
            () =>
              activeIndex > 0
                ? (activeIndex -= 1)
                : (activeIndex = list.length - 1)
          "></div>
          <div class="b_box">
            <div :class="{ active: activeIndex == index }" v-for="(item, index) in list" :key="index">
              <h1>{{ item.year }}</h1>
              <div class="lc_content">
                <div class="img">
                  <img :src="$baseURL + item.thumb" alt="" />
                </div>
                <div class="text">
                  <h2>{{ item.year }}</h2>
                  <p>{{ item.des }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="iconfont icon-jiantou" @click="
            () =>
              activeIndex < list.length - 1
                ? (activeIndex += 1)
                : (activeIndex = 0)
          "></div>
        </div>
        <div class="year_list">
          <div v-for="(item, index) in list" :key="index" :class="{ active: activeIndex == index }"
            @click="activeIndex = index">
            <span>{{ item.year }}</span>
            <i class="iconfont icon-tuxingxia"></i>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import service from "@/assets/js/service";

export default {
  data() {
    return {
      activeIndex: 0,
      list: [],
    };
  },
  methods: {
    async aboutHistory() {
      let res = await service.aboutHistory();
      if (res.code == 1) {
        this.list = res.data.history;
      }
    },
  },
  created() {
    this.aboutHistory();
  },
};
</script>

<style lang="less" scoped>
section {
  margin: 0 auto;
  padding: 110px 0;
  background-image: url(../../assets/image/about_lc_bg.png);
  background-position-y: bottom;
  background-repeat: no-repeat;
  background-size: 100% auto;

  h1 {
    font-size: 30px;
  }

  .box {
    .wrap {
      margin: 60px 0 170px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .iconfont {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        border: 1px solid var(--themeColor);
        color: var(--themeColor);
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          color: #fff;
          background: var(--themeColor);
        }
      }

      .b_box {
        &>div {
          display: none;
          position: relative;

          h1 {
            color: rgba(0, 73, 152, 0.1);
            font-size: 300px;
            font-weight: bold;
            line-height: 0.8;
            padding: 0 5vw;
          }

          &.active {
            display: block;
          }

          .lc_content {
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            display: flex;
            align-items: center;

            .img {
              width: 62%;
              margin-right: 30px;

              img {
                width: 100%;
              }
            }

            .text {
              flex: 1;

              h2 {
                font-weight: bold;
                color: var(--themeColor);
                line-height: 2;
              }

              p {
                color: #666;
              }
            }
          }
        }
      }
    }

    .year_list {
      display: flex;
      justify-content: space-between;

      div {
        display: flex;
        flex-direction: column;
        align-items: center;
        transition: all 0.3s;
        cursor: pointer;

        span {
          font-size: 20px;
          font-weight: 600;
          transition: all 0.3s;
        }

        .iconfont {
          font-size: 12px;
          opacity: 0;
          transform: scale(0.7);
          margin-top: 10px;
          color: var(--themeColor);
          transition: all 0.3s;
        }

        &.active {
          transform: translateY(-30px);

          span {
            transform: scale(1.3);
            color: var(--themeColor);
          }

          .iconfont {
            opacity: 1;
          }
        }
      }
    }
  }
}

@media (max-width: 950px) {
  section {
    padding: 90px 0;

    .box {
      .wrap {
        margin: 40px 0 60px;
        position: relative;

        .iconfont {
          position: absolute;
          top: 30%;
          z-index: 2;
          background: var(--themeColor);
          color: #fff;

          &:first-of-type {
            left: 5px;
          }

          &:last-of-type {
            right: 5px;
          }
        }

        .b_box {
          &>div {
            h1 {
              display: none;
            }

            .lc_content {
              padding: 0;
              position: static;
              display: block;

              .img {
                width: 100%;
                margin: 0;
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 600px) {
  section {
    padding: 40px 0;

    .box {
      .year_list {
        flex-wrap: wrap;
        justify-content: flex-start;

        div {
          margin: 0 10px;

          .iconfont {
            display: none;
          }

          &.active {
            transform: none;

            span {
              transform: none;
            }
          }
        }
      }
    }
  }
}
</style>